import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'ttag';

import UmbrellaIcon from '@svg/umbrella.svg';
import { safePurchase } from '@urls';
import { MAX_SAFE_PURCHASE_COST } from '@constants';
import { getShafaAbsoluteUrl, prettierNumber } from '@utils/common';
import { useRegion } from '@hook/useRegion';
import { Link } from '@ui/Link';

import s from './ProductDetailsSafePaymentHelpLink.sss';

interface Props {
  className?: string,
}

export const ProductDetailsSafePaymentHelpLink: React.FC<Props> = ({
  className,
}) => {
  const history = useHistory();
  const { currencyName } = useRegion();

  const maxSafePaymentCost = prettierNumber(MAX_SAFE_PURCHASE_COST);

  return (
    <Link
      className={classNames(s.link, className)}
      href={getShafaAbsoluteUrl(history.createHref({ pathname: safePurchase }))}
      theme="black"
      rel="nofollow"
      target="_blank"
    >
      <UmbrellaIcon
        className={s.icon}
        width='24'
        height='24'
      />

      <span>
        {t`Захищаємо покупки до ${maxSafePaymentCost} ${currencyName}`}
      </span>
    </Link>
  );
};
